import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
export const theme = createTheme({
  components:{
    MuiDrawer:{styleOverrides:{paper:{backgroundColor:'#162346',color:'white'}}},
    MuiAppBar:{styleOverrides:{root:{backgroundColor:'white', color:'gray'}}},
    MuiTextField:{
      defaultProps:{size:'medium',InputLabelProps:{shrink:true}, InputProps:{style:{height:40, fontSize:16}}},
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff'
          }
        }
      }
    },
    // MuiInputLabel: {styleOverrides: {root: {fontSize: '1.25rem', },},},
    MuiCard:{styleOverrides:{root:{borderRadius:10, padding:10, minWidth:'300px', boxShadow:'0 0 10px 0 rgba(100,100,100,0.3)'}}},
    MuiCardHeader:{styleOverrides:{root:{borderBottom:'3px solid #162346', padding:5, color:'#162346', marginBottom:15}}},
    MuiButton:{styleOverrides:{root:{borderRadius:5, margin:'5px', padding:7, borderWidth:'2px', fontWeight:'800', minWidth:'100px'}}},
  },
  palette: {
    primary: {
      main: '#162346',
    },
    success: {
      main: '#62BCBD',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    }, 
     background: {
      // Matches index.css body background so CssBaseline doesn't repaint it white.
      default: '#F4F6F9',
    },
  },
});